import { Component, inject, OnInit } from '@angular/core';
import {
  AuthService,
  NavbarcartComponent,
} from 'gung-standard';
import { first } from 'rxjs';

@Component({
  selector: 'cult-navbar-cart',
  templateUrl: './cult-navbar-cart.component.html',
  styleUrls: ['./cult-navbar-cart.component.scss'],
  standalone: false
})
export class CultNavbarCartComponent extends NavbarcartComponent implements OnInit {
  protected authService = inject(AuthService);

  isReturNoPrice = false;

  ngOnInit() {
    super.ngOnInit();
    this.authService
      .getCurrentUser()
      .pipe(first())
      .subscribe(user => {
        this.isReturNoPrice = user.roles.includes('RETUR_NOPRICE');
      });
  }
}
